import {useEffect} from 'react';
import {useQuery} from '@apollo/react-hooks';
import {validacion, defaults, dev} from 'lib.common';

const {esVarNullUndef} = validacion;
const {funcionVacia} = defaults;

export default function useApolloQ(
   query,
   {
      callbackProcesarData = funcionVacia,
      callbackError = funcionVacia,
      callbackLoading = funcionVacia
   } = {},
   apolloOptions = {}
) {
   function onCompleted(data) {
      if (!esVarNullUndef(data)) {
         callbackProcesarData(data);
      }
   }

   function onError(error) {
      console.log('🚀 ~ file: useApolloQ.js:24 ~ onError ~ error:', error);
      let eMsg = '';
      if (!esVarNullUndef(error)) {
         eMsg = eMsg + dev.getErrorMsg(error);
      }
      if (eMsg !== '') {
         callbackError(eMsg);
      }
   }

   const {data, loading, called, error, ...apolloResult} = useQuery(query, {
      ...apolloOptions,
      onCompleted,
      onError
   });

   useEffect(() => {
      callbackLoading(loading);
   }, [loading]);

   return {data, loading, called, error, ...apolloResult};
}
